import React from 'react'

import {createItemComponent} from '@base-uikit/items/Item'
import List from '@base-uikit/lists/List'
import ListSelect from '@base-uikit/selects/ListSelect'

import type {CalendarDatePresetType} from './types'

import css from './DatePresetsList.css'

const CalendarPresetItem = createItemComponent({
  renderLabel: (label, props) => {
    const item: CalendarDatePresetType = props.item
    return (
      <div className={css.calendarPresetItem}>
        <div className={css.calendarPresetItemLabel}>{item.label}</div>
        <div className={css.calendarPresetItemTime}>{item.valueHint}</div>
      </div>
    )
  },
})

export const DatePresetsList = (props) => {
  return (
    <ListSelect
      {...props}
      isItemSelected={(item) => props.value && item.value === props.value}
      renderItem={CalendarPresetItem.render}
      items={props.datePresets()}
      onValueChange={(item) => props.onValueChange(item.value)}
      listComponent={List}
    />
  )
}
